// extracted by mini-css-extract-plugin
export default {"Spinner":"Loader_Spinner__1iFnP"};